<div class="app-banner" >
    <div class="row">
      <div class="col-1 text-center align-middle first-item"><img class="icon" src="{{ theme.iconUrl }}"></div>
      <div class="col-6" style="display: flex;align-items: center;">
        <div class="align-left">
          <p transloco="app_banner.title">Keep your results at the tip of your finger.</p>
          <span transloco="app_banner.body">Download the mobile app.</span>
        </div>
      </div>
      <div class="col-5 last-item text-center">
        <div class="row">
          <div class="col-6">
            <a href="{{ theme.play_container.app_store }}" target="_blank"><img class="linkBtn" src="/assets/common/img/PNG/app_store.png"></a>
          </div>
          <div class="col-6">
            <a href="{{ theme.play_container.play_store }}" target="_blank"><img class="linkBtn" src="/assets/common/img/PNG/play_store.png"></a>
          </div>
        </div>
      </div>
    </div>
  </div>